import Particle, {
  checkParticle,
  moveParticle,
  drawParticle
} from "./particle";

export default class Orbit {
  constructor({ direction = 1, radius = 100, stars = 10 }) {
    this.direction = direction;
    this.radius = radius;
    this.particles = [];

    this.renderNo = 0;

    this.setupBelt(stars);
  }

  setupBelt(maxStarsNo) {
    const { particles, radius } = this;

    for (let i = 0; i < maxStarsNo; i++) {
      const particle = new Particle({ ringRadius: radius });
      particles.push(particle);
    }
  }

  setColor(color) {
    this.particles.forEach(particle => (particle.color = color));
  }

  render(ctx) {
    const { particles, direction, radius } = this;

    for (let i = 0; i < this.renderNo; i++) {
      const particle = particles[i];

      checkParticle(particle, radius);
      moveParticle(particle, radius, direction);
      drawParticle(particle, ctx);
    }
  }
}
